import { RadioButtonOption } from "../../../common/enums";

export const EXCAVATION_AND_POLING_CHECKLIST_VERSION_2026_02 = 1;

export type ExcavationAndPolingChecklist = {
    checklistVersion: number | undefined;
    isSubmittedToCountyBoard: RadioButtonOption;
    howIsAreaBlockedOff: string;
    isTestsDoneForLab: RadioButtonOption;
    isReleaseDone: RadioButtonOption;
    isCablesInTheGround: RadioButtonOption;
    isProductPipesOrTheLikeInTheGround: RadioButtonOption;
    isDepperThan120Centimeters: RadioButtonOption;
    isRiskOfRace: RadioButtonOption;
    canSafleyDecendShaft: RadioButtonOption;
    isGasPartOfTheTest: RadioButtonOption;
    isManHoleGuardAvailable: RadioButtonOption;
    isMassesOilContanimated: RadioButtonOption;
    
    isSubmittedToCountyBoardForExcavation: RadioButtonOption;
    isGasTestedInHoleBeforeEntry: RadioButtonOption;
    isTrainedExcavationGuardAvailable: RadioButtonOption;
};
